
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

interface FloatingButtonProps {
  onClick: () => void;
  primaryColor?: string;
  secondaryColor?: string;
}

export const FloatingButton = ({ 
  onClick,
  primaryColor = '#4B89FF',
  secondaryColor = '#7E69AB'
}: FloatingButtonProps) => {
  return (
    <div className="relative">
      {/* Ripple effect */}
      <motion.div
        className="absolute inset-0 rounded-full"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.2, 0, 0.2]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatDelay: 1,
          ease: "easeInOut"
        }}
        style={{
          background: `linear-gradient(45deg, ${primaryColor}, ${secondaryColor})`
        }}
      />
      <motion.button
        onClick={onClick}
        className="relative p-3.5 rounded-full shadow-lg hover:shadow-xl transition-shadow duration-300"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        style={{
          background: `linear-gradient(45deg, ${primaryColor}, ${secondaryColor})`
        }}
      >
        <MessageCircle className="w-6 h-6 text-white" />
      </motion.button>
    </div>
  );
};
